import { LeadStatus } from '../types/lead';

export interface PipelineStatusOption {
  value: LeadStatus;
  label: string;
}

/** Statuses shown in SMS Inbox filter + Change Status menu */
export const SMS_INBOX_PIPELINE_STATUSES: PipelineStatusOption[] = [
  { value: 'app_out', label: 'App Out' },
  { value: 'app_in', label: 'App In' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'contract', label: 'Contract' },
  { value: 'funded', label: 'Funded' },
  { value: 'follow_up', label: 'Follow Up' },
  { value: 'not_interested', label: 'Not Interested' },
  { value: 'do_not_call', label: 'DNC' },
  { value: 'no_answer', label: 'No Answer' },
];

export const LEAD_STATUS_CHANGE_OPTIONS: PipelineStatusOption[] = [
  { value: 'interested', label: 'Interested' },
  ...SMS_INBOX_PIPELINE_STATUSES.filter((s) => s.value !== 'interested'),
  { value: 'unqualified', label: 'Unqualified' },
];

export function formatLeadStatusLabel(status?: string | null): string {
  if (!status) return 'Unknown';
  const found = SMS_INBOX_PIPELINE_STATUSES.find((s) => s.value === status);
  if (found) return found.label;
  return status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export const LEAD_STATUS_DESCRIPTIONS: Partial<Record<LeadStatus, string>> = {
  app_out:
    'Application sent. Waiting for merchant to complete and upload statements.',
  app_in: 'Application received. Reviewing merchant documents.',
  submitted: 'Application submitted and under review.',
  contract: 'Contract sent or pending merchant signature.',
  funded: 'Deal funded successfully.',
  follow_up: 'Scheduled for follow-up contact.',
  not_interested: 'Merchant is not interested at this time.',
  do_not_call: 'Do not contact — merchant opted out or marked DNC.',
  no_answer: 'No answer on recent contact attempts.',
  interested: 'Merchant expressed interest.',
  unqualified: 'Lead does not meet qualification criteria.',
};

export const LEAD_STATUS_PILL: Record<string, string> = {
  app_out: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-400',
  app_in: 'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-400',
  submitted: 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-400',
  contract: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-400',
  funded: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400',
  follow_up: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-400',
  not_interested: 'bg-muted text-muted-foreground',
  do_not_call: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-400',
  no_answer: 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-400',
  interested: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-400',
  unqualified: 'bg-muted text-muted-foreground',
};

export function leadStatusPillClass(status?: string | null): string {
  if (!status) return 'bg-muted text-muted-foreground';
  return LEAD_STATUS_PILL[status] ?? 'bg-muted text-muted-foreground';
}
